import { connect } from 'react-redux';
import { setAllCookiesAccepted } from '../../publicSession/actions';
import { showCookieSettingsPopup } from '../../Modals/redux/actionCreators';
var mapDispatchToProps = {
    onAccept: setAllCookiesAccepted,
    onManageInfo: showCookieSettingsPopup,
};
export default connect(null, mapDispatchToProps);
//# sourceMappingURL=CookiesBanner.container.js.map